// ANALYTICS ARCHITECTURE — Privacy-conscious event tracking
// BACKEND INTEGRATION POINT: Replace the trackEvent body with your analytics provider call
// (e.g. Google Analytics 4, Mixpanel, PostHog) — but NEVER send sensitive health data

export type AnalyticsEvent =
  | "journey_started" |"primary_need_selected" |"health_concern_selected" |"concern_selected" |"question_answered" |"care_recommendation_shown" |"department_recommended" |"doctor_viewed" |"doctor_selected" |"doctor_journey_started" |"booking_started" |"booking_completed" |"whatsapp_clicked" |"call_clicked" |"emergency_clicked" |"emergency_triggered" |"health_checkup_started" |"programme_viewed" |"journey_completed";

export interface EventPayload {
  event: AnalyticsEvent;
  // NOTE: Never include symptom descriptions, diagnosis-adjacent data, or personally identifiable info
  departmentId?: string;
  doctorId?: string;
  step?: number;
  source?: string;
  primaryNeed?: string;
}

export function trackEvent(payload: EventPayload): void {
  // BACKEND INTEGRATION POINT: Send event to analytics service
  if (process.env.NODE_ENV === "development") {
    console.log("[Analytics]", payload);
  }
  // Example: window.gtag?.('event', payload.event, { department: payload.departmentId });
}